const phoneRegExp = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/

export function isPhoneNumber(value: string): boolean {
  return phoneRegExp.test(value);
}
